<template>
	<div id="app">
		<!-- <Top /> -->
		<router-view ref="hometo" />
	</div>
</template>

<script>
	import Top from "./components/public/top";

	export default {
		name: "App",
		components: {
			Top
		},
		data() {
			return {
				screenSize: '',
				lng: ''
			};
		},
		created() {
			// document.getElementById('load-box').remove();
		},
		mounted() {
			// 监听窗口大小变化
			window.addEventListener("resize", this.handleResize);
			// 初始设置屏幕大小状态
			this.setSize();
			if (this.$route.query.lng) {
				localStorage.setItem('locale', this.$route.query.lng)
				// localStorage.setItem('locale', 'zh')
			} else {
        if(!localStorage.getItem('locale')){
          localStorage.setItem('locale', 'en')
        }

			}
		},
		methods: {
			handleResize() {
				// 窗口大小变化时重新设置屏幕大小状态
				this.setSize();
			},
			setSize() {
				const screenWidth =
					window.innerWidth || document.documentElement.clientWidth;
				console.log()
				if (screenWidth >= 768) {
					this.screenSize = "medium";
				} else {
					this.screenSize = "small";
				}
				if (this.screenSize !== sessionStorage.getItem('screenSize')) {
					sessionStorage.setItem('screenSize', this.screenSize)
					window.location.reload()
				}

				this.$store.dispatch("setScreenSize", this.screenSize);
				console.log(this.$store);
			}
		}
	};
</script>

<style>
	@media screen and (max-width: 768px) {
		body {
			min-width: 100% !important;
			min-height: 100vh;
			background-color: #000000 !important;
		}

		#app {
			min-width: 100% !important;
			min-height: 100vh;
			background-color: #000000 !important;
		}
	}

	body {
		min-width: 1200px;
		width: 100%;
		min-height: 100vh;
		background-color: #000000 !important;
	}

	#app {
		min-width: 1200px;
		width: 100%;
		min-height: 100vh;
		background-color: #000000 !important;
	}

	.preventReClick {
		pointer-events: none;
		background: linear-gradient(#ffffff, #999999) !important;
		/*background: #929292 !important;*/
	}

	.mint-msgbox {
		/*background-image: url(../static/image/tisBG.png);*/
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-color: transparent !important;
		width: 94%;
	}

	.mint-msgbox-btn {
		background-color: transparent !important;
		width: 1.03rem !important;
		flex: none !important;
		border-radius: 0.18rem !important;
		color: #000000 !important;
		font-size: 0.2rem !important;
		background: linear-gradient(#fffc00, #db7100);
		line-height: 0.36rem !important;
		margin-bottom: 0.34rem !important;
	}

	.mint-msgbox-btn:first-child {
		margin-left: 0.33rem !important;
	}

	.mint-msgbox-content {
		border-bottom: 0 !important;
		padding: 0.76rem 0.26rem 0.42rem !important;
	}

	.mint-msgbox-message {
		color: #ffffff !important;
		font-size: 0.1867rem !important;
		line-height: 0.2518rem !important;
		text-transform: uppercase !important;
	}

	.mint-msgbox-btns {
		height: auto !important;
		line-height: normal !important;
		padding-bottom: 0.28rem !important;
		justify-content: center !important;
		flex-flow: row-reverse !important;
	}

	.mint-toast.is-placebottom,
	.mint-toast.is-placemiddle {
		width: max-content !important;
	}

	.load {
		display: flex;
		justify-content: center;
		margin-top: 0.2rem;
	}

	.nolist {
		color: #ffffff;
		margin-top: 0.2rem;
		text-align: center;
	}

	.slide-verify {
		background: #ffffff;
	}

	.slide-verify-slider {
		width: auto !important;
	}

	.movebutton span {
		display: none;
		z-index: -1;
	}

	.movebutton:active {
		transform: translateX(6px) translateY(6px);
		position: relative;
		overflow: hidden;
		transition-delay: 0.1s;
	}

	.movebutton:active span {
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5) !important;
		z-index: -1;
	}

	.content {
		width: calc(100% - 300px);
		height: 100%;
		margin: 0 auto;
		z-index: 2;
		display: flex;
		align-items: center;
		position: relative;

	}

	.flex-bet {
		display: flex;
		justify-content: space-between;
	}

	.flex-col {
		display: flex;
		flex-direction: column;

	}

	.flex-center {
		display: flex;
		align-items: center;
		justify-content: center;

	}

	.font64 {
		font-size: .64rem;
	}

	.font20 {
		font-size: .2rem;
	}

	.font200 {
		font-size: 2rem;
	}

	.font120 {
		font-size: 1.2rem;
	}

	.font600 {
		font-weight: 600;
	}

	.white {
		color: white;
	}

	.whiteTitle {
		background: linear-gradient(180deg, #FFF 0%, #999 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.green {
		color: #4CD964;
	}

	.blue {
		color: #00E5E0;
	}

	.gray {
		color: rgba(255, 255, 255, 0.6);
	}

	.flex-item {
		display: flex;
		align-items: center;
	}

	.gap46 {
		gap: .46rem;
	}

	.gap36 {
		gap: .36rem;
	}

	.gap86 {
		gap: .86rem;
	}

	.gap16 {
		gap: .16rem;
	}

	.gap25 {
		gap: .25rem;
	}

	.gap3657 {
		gap: 1.57rem;
	}

	.font14 {
		font-size: .14rem;
	}

	.font48 {
		font-size: .48rem;
	}

	.font24 {
		font-size: .24rem;
	}

	.font16 {
		font-size: .16rem;
	}
.font36{
  font-size: .36rem;
}
	.font96 {
		font-size: .96rem;
	}

	.font700 {
		font-family: 'Genova-Black';
		font-weight: 700;
	}

	.gap8 {
		gap: 0.08rem
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue